/**
 * PEAK — Cart v3 (shared by Patient + Provider cards)
 * Vanilla JS. One delegated listener set, instant feedback:
 * the drawer opens the moment the icon is tapped ("Adding…"), then fills
 * from /cart.js as soon as the add succeeds.
 */
(function () {
  'use strict';
  if (window.__peakCartV3) return;
  window.__peakCartV3 = true;

  var DRAWER_ID = 'peak-cart-drawer';
  var money = null;

  function fmt(cents) {
    try {
      var cur = (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'USD';
      money = money || new Intl.NumberFormat(document.documentElement.lang || undefined, { style: 'currency', currency: cur });
      return money.format(cents / 100);
    } catch (e) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function esc(s) {
    return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  /* ---------- drawer ---------- */
  function injectStyles() {
    if (document.getElementById('peak-cart-drawer-styles')) return;
    var s = document.createElement('style');
    s.id = 'peak-cart-drawer-styles';
    s.textContent =
      '#' + DRAWER_ID + '{position:fixed;inset:0;z-index:2147483000;visibility:hidden;pointer-events:none}' +
      '#' + DRAWER_ID + '.is-open{visibility:visible;pointer-events:auto}' +
      '.pcd-overlay{position:absolute;inset:0;background:rgba(10,11,11,.5);opacity:0;transition:opacity .15s}' +
      '.is-open .pcd-overlay{opacity:1}' +
      '.pcd-panel{position:absolute;top:0;right:0;height:100%;width:min(420px,100%);background:#fff;color:#25282C;display:flex;flex-direction:column;transform:translateX(100%);transition:transform .2s ease;box-shadow:-8px 0 30px rgba(0,0,0,.15)}' +
      '.is-open .pcd-panel{transform:none}' +
      '.pcd-head{display:flex;align-items:center;justify-content:space-between;padding:1rem 1.25rem;border-bottom:1px solid #eee;font-weight:700;letter-spacing:.06em;text-transform:uppercase;font-size:.85rem}' +
      '.pcd-close{background:none;border:0;font-size:1.6rem;line-height:1;cursor:pointer;color:inherit;padding:.25rem}' +
      '.pcd-body{flex:1;overflow:auto;padding:1rem 1.25rem}' +
      '.pcd-item{display:flex;gap:.85rem;padding:.75rem 0;border-bottom:1px solid #f0f0f0}' +
      '.pcd-item img{width:64px;height:64px;object-fit:cover;border-radius:4px;background:#F3F4F2;flex:none}' +
      '.pcd-item-title{font-weight:700;font-size:.9rem;line-height:1.3;color:inherit;text-decoration:none}' +
      '.pcd-item-meta{font-size:.78rem;color:#5B5F5C;margin-top:.15rem}' +
      '.pcd-item-price{margin-left:auto;font-weight:700;font-size:.9rem;white-space:nowrap}' +
      '.pcd-empty,.pcd-loading{padding:2rem 0;text-align:center;color:#5B5F5C}' +
      '.pcd-foot{padding:1rem 1.25rem;border-top:1px solid #eee}' +
      '.pcd-sub{display:flex;justify-content:space-between;font-weight:700;margin-bottom:.8rem}' +
      '.pcd-btn{display:block;text-align:center;padding:.85rem 1rem;border-radius:4px;font-weight:700;letter-spacing:.06em;text-transform:uppercase;font-size:.78rem;text-decoration:none}' +
      '.pcd-btn--primary{background:#29A947;color:#fff;margin-bottom:.5rem}' +
      '.pcd-btn--ghost{border:1.5px solid #25282C;color:#25282C}';
    document.head.appendChild(s);
  }

  function getDrawer() {
    var d = document.getElementById(DRAWER_ID);
    if (d) return d;
    injectStyles();
    d = document.createElement('div');
    d.id = DRAWER_ID;
    d.setAttribute('role', 'dialog');
    d.setAttribute('aria-modal', 'true');
    d.setAttribute('aria-label', 'Shopping cart');
    d.innerHTML =
      '<div class="pcd-overlay" data-pcd-close></div>' +
      '<div class="pcd-panel"><div class="pcd-head"><span>Your cart</span>' +
      '<button type="button" class="pcd-close" data-pcd-close aria-label="Close cart">&times;</button></div>' +
      '<div class="pcd-body" data-pcd-body></div><div class="pcd-foot" data-pcd-foot hidden></div></div>';
    document.body.appendChild(d);
    return d;
  }

  function openDrawer() {
    var d = getDrawer();
    d.classList.add('is-open');
    document.documentElement.style.overflow = 'hidden';
  }

  function closeDrawer() {
    var d = document.getElementById(DRAWER_ID);
    if (d) d.classList.remove('is-open');
    document.documentElement.style.overflow = '';
  }

  function setLoading() {
    var d = getDrawer();
    d.querySelector('[data-pcd-body]').innerHTML = '<p class="pcd-loading">Adding to cart…</p>';
    d.querySelector('[data-pcd-foot]').hidden = true;
  }

  function renderCart(cart) {
    var d = getDrawer();
    var body = d.querySelector('[data-pcd-body]');
    var foot = d.querySelector('[data-pcd-foot]');
    if (!cart.items.length) {
      body.innerHTML = '<p class="pcd-empty">Your cart is empty.</p>';
      foot.hidden = true;
      return;
    }
    body.innerHTML = cart.items.map(function (it) {
      var img = it.image ? '<img src="' + esc(it.image) + '" alt="' + esc(it.product_title) + '" loading="lazy">' : '<img alt="">';
      var variant = it.variant_title && it.variant_title !== 'Default Title' ? '<div class="pcd-item-meta">' + esc(it.variant_title) + '</div>' : '';
      return '<div class="pcd-item">' + img +
        '<div><a class="pcd-item-title" href="' + esc(it.url) + '">' + esc(it.product_title) + '</a>' + variant +
        '<div class="pcd-item-meta">Qty ' + it.quantity + '</div></div>' +
        '<div class="pcd-item-price">' + fmt(it.final_line_price) + '</div></div>';
    }).join('');
    foot.hidden = false;
    foot.innerHTML =
      '<div class="pcd-sub"><span>Subtotal</span><span>' + fmt(cart.total_price) + '</span></div>' +
      '<a class="pcd-btn pcd-btn--primary" href="/checkout">Checkout</a>' +
      '<a class="pcd-btn pcd-btn--ghost" href="/cart">View cart</a>';
  }

  function updateCount(count) {
    var sels = ['[data-peak-cart-count]', '[data-cart-count]', '.cart-count-bubble [aria-hidden="true"]', '.cart-count-bubble span', '.cart-bubble__text-count', '#cart-icon-bubble .cart-count-bubble'];
    sels.forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) {
        if (el.children.length === 0) el.textContent = count;
      });
    });
    document.querySelectorAll('.cart-count-bubble, .cart-bubble').forEach(function (el) {
      el.classList.toggle('hidden', count === 0);
      if (count > 0) el.removeAttribute('hidden');
    });
    document.dispatchEvent(new CustomEvent('peak:cart:updated', { detail: { count: count } }));
  }

  function fetchCart() {
    return fetch('/cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' }).then(function (r) { return r.json(); });
  }

  /* ---------- helpers ---------- */
  function setMsg(form, text, state) {
    var el = form.querySelector('[data-form-message]');
    if (!el) return;
    el.textContent = text || '';
    if (state) el.setAttribute('data-state', state); else el.removeAttribute('data-state');
  }

  function triggerButtons(form) {
    var list = Array.prototype.slice.call(form.querySelectorAll('[data-add-to-cart]'));
    if (form.id) {
      document.querySelectorAll('[data-add-to-cart][form="' + form.id + '"]').forEach(function (b) { if (list.indexOf(b) < 0) list.push(b); });
    }
    return list;
  }

  function setBtnState(form, state) {
    triggerButtons(form).forEach(function (b) {
      b.classList.toggle('is-loading', state === 'loading');
      b.classList.toggle('is-added', state === 'added');
      b.setAttribute('aria-busy', state === 'loading' ? 'true' : 'false');
      if (state === 'loading') b.disabled = true;
      else if (b.dataset.soldOut !== 'true') b.disabled = false;
    });
    if (state === 'added') {
      setTimeout(function () { setBtnState(form, 'idle'); }, 1600);
    }
  }

  /* ---------- add to cart ---------- */
  function onSubmit(e) {
    var form = e.target;
    if (!form.matches || !form.matches('[data-product-form]')) return;
    if (form.getAttribute('data-quick-add') === 'false') return;      // native submit
    if (e.submitter && e.submitter.name === 'checkout') return;        // legacy Buy Now
    e.preventDefault();

    var sel = form.querySelector('[data-variant-select]');
    if (sel && !sel.value) { setMsg(form, 'Please choose an option.', 'error'); return; }
    if (form.dataset.busy === 'true') return;
    form.dataset.busy = 'true';

    setMsg(form, '');
    setBtnState(form, 'loading');
    setLoading();                 // instant feedback
    openDrawer();

    var body = new FormData(form);
    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: body })
      .then(function (r) {
        return r.json().then(function (data) {
          if (!r.ok) throw new Error((data && (data.description || data.message)) || 'This item could not be added.');
          return data;
        });
      })
      .then(fetchCart)
      .then(function (cart) {
        renderCart(cart);
        updateCount(cart.item_count);
        setBtnState(form, 'added');
      })
      .catch(function (err) {
        closeDrawer();
        setMsg(form, err.message, 'error');
        setBtnState(form, 'idle');
      })
      .then(function () { form.dataset.busy = 'false'; });
  }

  /* ---------- variant price sync ---------- */
  function variantsFor(card) {
    if (card._peakVariants) return card._peakVariants;
    var s = card.querySelector('[data-variant-data]');
    try { card._peakVariants = JSON.parse(s.textContent); } catch (e) { card._peakVariants = []; }
    return card._peakVariants;
  }

  function onChange(e) {
    var sel = e.target;
    if (sel.matches && sel.matches('[data-quantity-input]')) {
      if (!(parseInt(sel.value, 10) >= 1)) sel.value = 1;
      return;
    }
    if (!sel.matches || !sel.matches('[data-variant-select]')) return;
    var card = sel.closest('[data-product-card]');
    if (!card) return;
    var v = variantsFor(card).filter(function (x) { return String(x.id) === sel.value; })[0];
    if (!v) return;

    var p = card.querySelector('[data-current-price]');
    var c = card.querySelector('[data-compare-price]');
    if (p) p.textContent = fmt(v.price);
    if (c) {
      if (v.compare_at_price && v.compare_at_price > v.price) { c.textContent = fmt(v.compare_at_price); c.style.display = ''; }
      else { c.style.display = 'none'; }
    }
    card.querySelectorAll('[data-add-to-cart]').forEach(function (b) {
      b.dataset.soldOut = v.available ? 'false' : 'true';
      b.disabled = !v.available;
      var t = b.querySelector('[data-add-to-cart-text]');
      if (t) t.textContent = v.available ? 'Add to cart' : 'Sold out';
    });
  }

  /* ---------- clicks: qty steppers + drawer close ---------- */
  function onClick(e) {
    var t = e.target;
    if (!t.closest) return;
    if (t.closest('[data-pcd-close]')) { closeDrawer(); return; }

    var dec = t.closest('[data-quantity-decrease]');
    var inc = t.closest('[data-quantity-increase]');
    if (dec || inc) {
      var wrap = (dec || inc).closest('[data-quantity-wrapper]');
      var input = wrap && wrap.querySelector('[data-quantity-input]');
      if (!input) return;
      var n = parseInt(input.value, 10) || 1;
      input.value = dec ? Math.max(1, n - 1) : n + 1;
    }
  }

  document.addEventListener('submit', onSubmit);
  document.addEventListener('change', onChange);
  document.addEventListener('click', onClick);
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });
})();